import { AsyncGridColumns } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.violation',
    field: 'title',
    flex: 1,
    sortable: false,
  },
  {
    headerName: 'column.amount',
    field: 'cost',
    flex: 1,
    renderCell: ({ value }) => value && value.toLocaleString(),
  },
]
